import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FirstAccess } from '../interfaces/first-access.interface';

@Component({
  selector: 'app-first-access',
  templateUrl: './first-access.page.html',
  styleUrls: ['../login.page.scss']
})
export class FirstAccessComponent extends BaseClass {

  public formGroup: UntypedFormGroup;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _authService: AuthService,
    private router: Router
  ) {
    super(_toastController, _translationService);
    this.formGroup = new UntypedFormGroup({
      'newPassword': new UntypedFormControl('', [ Validators.required ]),
      'confirmNewPassword': new UntypedFormControl('', [ Validators.required ])
    });
  }

  public async saveAndContinue(formGroup: UntypedFormGroup) {
    if (formGroup.valid) {
      const credentials: FirstAccess = formGroup.getRawValue();

      if (credentials.newPassword !== credentials.confirmNewPassword) {
        this.notify(
          this._translationService.getTranslation(
            'login.passwordsDontMatch'
          ), 'danger'
        );
      } else {
        this._resetPassword( credentials );
      }

    } else {
      this.notify(
        this._translationService.getTranslation(
          'generic.missingFields'
        ), 'danger'
      );
    }
  }

  private _resetPassword(credentials: FirstAccess): void {
    this._authService.changePassword(
      credentials.newPassword
    ).subscribe(() => {
      this._authService.setPasswordChangeRequired(false);
      this.notifySuccess('login.passwordChanged');
      this.router.navigate([ 'dashboard' ]);

    }, (error) => this.notifyError( error ));
  }
}
